import { PDF_LINK_TEMPLATE } from "../../../../data/constants";

export const getVersionData = (serverVersion) => {
    //if (!serverVersion) return null;
    if (!serverVersion || typeof serverVersion != 'string') return null;

    const versionParts = serverVersion.split('.');
    if (versionParts.length < 2) return null;

    let major = parseInt(versionParts[0], 10);
    let minor = parseInt(versionParts[1], 10);

    const versions = [];

    for (let i = 0; i < 3; i++) {
        if (major < 1 || (major === 1 && minor < 0)) break;

        const versionString = `v${major}.${minor}`;
        const pdfLink = PDF_LINK_TEMPLATE.PDF_LINK.replace('{major}', major).replace('{minor}', minor);

        versions.push({
            version: versionString,
            pdfLink: pdfLink
        });

        minor--;
        if (minor < 0) {
            minor = 9; 
            major--;
        }
    }

    return versions;
};
